import React, { Component } from 'react';

export default class NavItem extends Component {
	handleClick(){
		this.props.onClick()
	}
	render() {
		return (
			<div className="NavItem">
				{this.props.children ? this.props.children : 0}
			</div>
		)
	}
}